import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="py-16" data-id="element-79" data-mp="3gf96f0gd6eb2">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-80" data-mp="3ggar7wn6mf5z">
        <p className="text-sm font-semibold uppercase tracking-[0.25em] text-[var(--lilac)]" data-id="element-81" data-mp="32nulgo2wc31d">
          🦋 Sistema Keto 365
        </p>
        <p className="mx-auto mt-4 max-w-xl text-white/70" data-id="element-82" data-mp="36qhgsyys063b">
          Menús, listas de compras y recetas con ingredientes del súper
          argentino, para todo el año.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-white/55" data-id="element-83" data-mp="398zqhbvha9n">
          Porque sostener el keto no debería depender de la fuerza de voluntad.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-84" data-mp="3le2fmgombj5f">
          <a href="mailto:soportesistemaketo365@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-[var(--lilac-light)]" data-id="element-85" data-mp="3qf9q4ni5awfs">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-86" data-mp="2ew6z8jgkxg5f" />
            soportesistemaketo365@gmail.com
          </a>
        </div>

        <div className="mt-10 border-t border-[var(--violet)]/25 pt-8" data-id="element-87" data-mp="3gapcti26iifg">
          <p className="text-xs text-white/40" data-id="element-88" data-mp="3gctq2qlywtse">
            © Sistema Keto 2026 — Material educativo. No reemplaza el consejo de
            un profesional de la salud.
          </p>
          <p className="mt-6 font-display text-xl font-semibold text-[var(--lilac-light)]" data-id="element-89" data-mp="3q7bxa5qlf7gy">
            “Más energía. Más salud. Mejor vos.”
          </p>
        </div>
      </div>
    </footer>;
}